import { Empty, Table, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import ComingSoon from '@/components/ComingSoon';
import type { CaseNotification } from './BulkyCase';
import { parseIso } from './time';

/**
 * Notifications sent to the resident. For bulky item removal cases they come from the case
 * workflow (dispatch / reschedule); lift cases keep the placeholder.
 */
export default function NotificationLog({
  bulky,
  notifications,
}: {
  bulky?: boolean;
  notifications?: CaseNotification[] | null;
}) {
  const { t } = useTranslation();
  if (!bulky) {
    return (
      <div className="m-4 min-h-[calc(100vh-202px)] bg-[#fff] dark:bg-[#141414]">
        <ComingSoon />
      </div>
    );
  }
  const rows = [...(notifications || [])].reverse();
  return (
    <div className="m-4 min-h-[calc(100vh-202px)] bg-[#fff] dark:bg-[#141414] p-4">
      {rows.length === 0 ? (
        <Empty className="mt-16" description={t('wf_noNotifications')} />
      ) : (
        <Table
          rowKey={(r) => r.at}
          pagination={false}
          dataSource={rows}
          columns={[
            {
              title: t('time'),
              dataIndex: 'at',
              width: 170,
              render: (v: string) => parseIso(v).format('DD/MM/YYYY HH:mm:ss'),
            },
            { title: t('handphone'), dataIndex: 'to', width: 140 },
            {
              title: 'SMS',
              dataIndex: 'text',
              render: (v: string) => <span className="whitespace-pre-wrap">{v}</span>,
            },
            {
              title: t('status'),
              dataIndex: 'status',
              width: 200,
              render: () => (
                <Tag bordered={false} color="processing">
                  {t('wf_notifStatusLogged')}
                </Tag>
              ),
            },
          ]}
        />
      )}
    </div>
  );
}
